import jwtDecode from 'jwt-decode';

const appleError = ({ provider, type, description, error }) => {
  return Error(error && error.description ? error.description : description);
};

/**
 * Loads Apple SDK.
 * @see https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js"
 */
export const load = () => {
  const appId = process.env.APPLE_CLIENT_ID;
  const redirectUri = process.env.APPLE_REDIRECT_URI;
  return new Promise(resolve => {
    const firstJS = document.getElementsByTagName('script')[0];
    const js = document.createElement('script');

    js.src =
      '//appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js';
    js.id = 'appleid-client';

    js.onload = () => {
      window.AppleID.auth.init({
        clientId: appId,
        scope: 'name email',
        redirectURI: redirectUri,
        usePopup: true //or false defaults to false
      });
      resolve();
    };

    if (!firstJS) {
      document.appendChild(js);
    } else {
      firstJS.parentNode.appendChild(js);
    }
  });
};

export const login = async () => {
  try {
    const data = await window.AppleID.auth.signIn();
    return data;
  } catch (err) {
    throw appleError({
      provider: 'apple',
      type: 'auth',
      description: 'Authentication failed',
      error: err
    });
  }
};

/**
 * Helper to generate user account data.
 * @param {Object} response
 */
export const generateUser = response => {
  const { authorization } = response;
  let decoded = {};
  try {
    decoded = jwtDecode(authorization.id_token);
  } catch (err) {
    console.log('decoding error');
  }

  return {
    token: {
      idToken: authorization.id_token,
      type: 'Apple'
    },
    profile: {
      ...decoded,
      ssoType: 'Apple'
    }
  };
};
